/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_revcomp_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reverse-complement, complement or reverse a DNA or RNA sequence (IUPAC-aware).`)
};

const es_revcomp_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcula el complemento inverso, el complemento o el inverso de una secuencia de ADN o ARN (compatible con IUPAC).`)
};

const de_revcomp_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilden Sie das reverse Komplement, das Komplement oder die Umkehrung einer DNA- oder RNA-Sequenz (IUPAC-fähig).`)
};

const nl_revcomp_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereken het omgekeerde complement, complement of de omkering van een DNA- of RNA-sequentie (IUPAC-bewust).`)
};

const fr_revcomp_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculez le complément inverse, le complément ou l'inverse d'une séquence d'ADN ou d'ARN (compatible IUPAC).`)
};

const it_revcomp_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcola il complemento inverso, il complemento o l'inverso di una sequenza di DNA o RNA (compatibile IUPAC).`)
};

const pt_br2_revcomp_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complemento reverso, complemento ou reversão de uma sequência de DNA ou RNA (com suporte a IUPAC).`)
};

const pt_revcomp_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule o complemento reverso, o complemento ou o reverso de uma sequência de ADN ou ARN (compatível com IUPAC).`)
};

const ja_revcomp_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNAまたはRNA配列の逆相補、相補、または逆順を求めます（IUPAC対応）。`)
};

const zh_revcomp_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对 DNA 或 RNA 序列进行反向互补、互补或反向处理（支持 IUPAC 简并码）。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const revcomp_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.revcomp_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("revcomp_tool_description", locale)
	if (locale === "en") return en_revcomp_tool_description(inputs)
	if (locale === "es") return es_revcomp_tool_description(inputs)
	if (locale === "de") return de_revcomp_tool_description(inputs)
	if (locale === "nl") return nl_revcomp_tool_description(inputs)
	if (locale === "fr") return fr_revcomp_tool_description(inputs)
	if (locale === "it") return it_revcomp_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_revcomp_tool_description(inputs)
	if (locale === "pt") return pt_revcomp_tool_description(inputs)
	if (locale === "ja") return ja_revcomp_tool_description(inputs)
	return zh_revcomp_tool_description(inputs)
};